import { useCallback } from "react"
import { Button, ParagraphSmall, useStyletron } from "@mezo-org/mezo-clay"
import { Link } from "@tanstack/react-router"

import {
  selectIsConnected,
  selectMats,
  selectMatsLoading,
  useDappSelector,
} from "#/redux-state"
import { routes } from "#/shared/constants"
import { usePosthogButtonClickedEvent } from "#/shared/hooks/posthog-events"
import { PosthogAnalyticsId } from "#/shared/types"

import OverviewRewardsMatsItem from "./OverviewRewardsMatsItem"
import OverviewSection from "./OverviewSection"

export default function OverviewRewards() {
  const isConnected = useDappSelector(selectIsConnected)
  const matsInLoadingState = useDappSelector(selectMatsLoading)

  const { totalMats, inactiveMats } = useDappSelector(selectMats)

  const { emitButtonClickedEvent } = usePosthogButtonClickedEvent()
  const [, theme] = useStyletron()

  const exploreButtonHandler = useCallback(() => {
    emitButtonClickedEvent(PosthogAnalyticsId.MATS_EXPLORE)
  }, [emitButtonClickedEvent])

  if (!isConnected) return null

  return (
    <OverviewSection header="Rewards" isLoading={matsInLoadingState}>
      <OverviewRewardsMatsItem
        title="mats"
        mats={totalMats}
        endEnhancer={() =>
          totalMats === 0 &&
          inactiveMats === 0 && (
            <Button
              $as={Link}
              onClick={exploreButtonHandler}
              href={routes.EXPLORE}
              shape="pill"
              kind="secondary"
              size="small"
            >
              Explore
            </Button>
          )
        }
      >
        {totalMats === 0 && (
          <ParagraphSmall
            marginTop={theme.sizing.scale100}
            color={theme.colors.contentSecondary}
            display="block"
            as="span"
          >
            Explore Mezo Economy to earn mats
          </ParagraphSmall>
        )}
      </OverviewRewardsMatsItem>
      {inactiveMats > 0 && (
        <OverviewRewardsMatsItem title="Unbridged mats" mats={inactiveMats}>
          <ParagraphSmall
            marginTop={theme.sizing.scale100}
            color={theme.colors.contentSecondary}
            display="block"
            as="span"
          >
            When you transfer funds to Mezo, your mats will automatically bridge
            to Mainnet
          </ParagraphSmall>
        </OverviewRewardsMatsItem>
      )}
    </OverviewSection>
  )
}
